import { Button as HdsButton } from 'hds-react';
import styled from 'styled-components';

export const $Button = styled(HdsButton)`
  hyphens: none;
  overflow-wrap: normal;
`;
